import logoFlamboyantFinal from '@/public/images/flamboyantgroup_final.svg';
import logoAmarelinhoFinal from '@/public/images/oamarelinho_final.svg';
import Image from 'next/image';

import icoFacebook from '@/public/images/logo-facebook-footer.svg';
import icoInstgram from '@/public/images/logo-instagram-footer.svg';
import icoLinkedIn from '@/public/images/logo-linkedin-footer.svg';

import Link from '@/components/link-with-utms';
import LiLinkCadastro from './li-cadastro';
import LinkCanalWhatsapp from './link-canal-whatsapp';
import LinkGrupoTelegram from './link-grupo-telegram';

export default function SiteFooter({ renderTop = true }) {
  return (
    <footer className="footer">
      {renderTop && (
        <div className="footer-top">
          <div className="container">
            <div className="row">
              <div className="col-12 d-flex flex-column flex-lg-row align-items-start justify-content-between">
                <div className="footer-top-col footer-logo">
                  <Link href="/">
                    <Image width={180} height={24} src={logoAmarelinhoFinal} alt="O Amarelinho" loading="eager" />
                  </Link>
                </div>
                <div className="footer-top-col">
                  <h2>
                    Candidato <span></span>
                  </h2>
                  <ul className="footer-list-links">
                    <li>
                      <Link href="/login">Entrar</Link>
                    </li>
                    <LiLinkCadastro />
                    <li>
                      <Link href="/vagas/vagas-az/a">Vagas de A-Z</Link>
                    </li>
                    <li>
                      <Link href="/vagas/por-local">Vagas por Local</Link>
                    </li>
                  </ul>
                </div>
                <div className="footer-top-col">
                  <h2>
                    Institucional <span></span>
                  </h2>
                  <ul className="footer-list-links">
                    <li>
                      <Link href="/institucional/como-funciona">Como funciona</Link>
                    </li>
                    <li>
                      <Link href="/fale-conosco">Fale Conosco</Link>
                    </li>
                    <li>
                      <Link href="/institucional/termos-uso">Termos de Uso</Link>
                    </li>
                    <li>
                      <Link href="/institucional/politica-privacidade">Política de Privacidade</Link>
                    </li>
                  </ul>
                </div>
                <div className="footer-top-col">
                  <h2>
                    Empregador <span></span>
                  </h2>
                  <ul className="footer-list-links">
                    <li>
                      <a
                        target="_blank"
                        rel="noreferrer"
                        href="https://wa.me/5511947933487?text=Ol%C3%A1%21%20Gostaria%20de%20mais%20informa%C3%A7%C3%B5es%20sobre%20como%20publicar%20uma%20vaga"
                      >
                        Publicar vagas
                      </a>
                    </li>
                  </ul>
                </div>

                <div className="footer-top-col">
                  <h2>Redes Sociais</h2>
                  <ul className="social d-flex align-items-center justify-content-start justify-content-lg-between">
                    <li>
                      <a href="https://pt.linkedin.com/company/o-amarelinho" target="_blank" rel="noreferrer">
                        <Image src={icoLinkedIn} alt="LinkedIn" />
                      </a>
                    </li>
                    <li>
                      <a href="https://www.instagram.com/oamarelinhoempregos/" target="_blank" rel="noreferrer">
                        <Image src={icoInstgram} alt="Instagram" />
                      </a>
                    </li>
                    <li>
                      <a href="https://www.facebook.com/OAmarelinho" target="_blank" rel="noreferrer">
                        <Image src={icoFacebook} alt="Facebook" />
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="footer-top-col">
                  <div className="footer-whatsapp-header">
                    <div className="container" style={{ textAlign: `center` }}>
                      <h3>Canal Oficial do Amarelinho</h3>
                      <p style={{ fontWeight: `normal` }}>Entre no canal para receber vagas diariamente! </p>
                    </div>
                  </div>

                  <LinkCanalWhatsapp />
                  <LinkGrupoTelegram />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <div className="footer-bottom">
        <div className="container">
          <div className="row">
            <div className="col-12 d-flex align-items-center justify-content-center">
              <Image width={180} height={52} src={logoFlamboyantFinal} alt="Flamboyant" />
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
